<template>
  <div v-if="customer">
    <modalWindow v-model="show" @ok="createSubmit()" @cancel="cancel()" @closed="onClose()" title="Editácia zákazníka" cancelText="Zrušïť" okText="Uložiť" :large="true">
      <form>
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <text-field field-id="companyName"
                            label="Názov"
                            placeholder="Zadaj názov firmy"
                            :maxlength="100"
                            v-model="customer.companyName"
                            validation="required|min:3|max:100"></text-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <select-field field-id="businessType"
                              label="Typ prevádzky"
                              :codelist="true"
                              :options="businessTypes"
                              :searchable="false"
                              v-model="customer.businessType"
                              validation="required"></select-field>
              </div>

              <div class="col-md-6">
                <select-field field-id="area"
                              label="Oblasť"
                              :options="validAreas"
                              v-model="customer.area"
                              validation="required"></select-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <number-field
                  v-model="customer.sortOrder"
                  label="Poradie pri rozvoze"
                  placeholder="Poradie"
                  field-id="sortOrder"
                  :min="1"
                  :max="50000"
                  :step="1"
                  validation="required|numeric|min_value:1|max_value:50000">
                </number-field>
              </div>
              <div class="col-md-6">
                <checkbox-field
                  field-id="deliveryNote"
                  v-model="customer.deliveryNote"
                  label="Požaduje dodací list">
                </checkbox-field>
              </div>

            </div>
          </div>
          <div class="col-md-6">
            <text-area-field field-id="note"
                             v-model.trim="customer.note"
                             label="Poznámka"
                             :maxlength="300"
                             validation="max:300"
                             css-class="note"></text-area-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <hr>
            <h4>Fakturačné údaje</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <label >
              <input type="checkbox" v-model="hasParent"/>
              Je pobočkou
            </label>
            <div v-if="hasParent" >
              <select-field field-id="parent"
                            :options="customers"
                            v-model="customer.parent"
                            validation="required"></select-field>
            </div>
          </div>
          <div class="col-md-3">
            <text-field field-id="companyId"
                        label="IČO"
                        placeholder="Zadaj IČ firmy"
                        :maxlength="8"
                        v-model="customer.companyId"
                        validation="required|digits:8"></text-field>
          </div>
          <div class="col-md-3">
            <text-field field-id="taxId"
                        label="DIČ"
                        placeholder="Zadaj DIČ firmy"
                        :maxlength="10"
                        v-model="customer.taxId"
                        validation="required|digits:10"></text-field>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>
                <input type="checkbox" v-model="vatPayer"/> Plátca DPH
              </label>
              <input class="form-control" id="vatId" placeholder="IČ DPH" :value="vatId()" name="vatId" maxlength="12" disabled>
            </div>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-md-3">
            <text-field field-id="streetName"
                        label="Ulica"
                        placeholder="Zadaj ulicu"
                        :maxlength="50"
                        v-model="customer.address.streetName"
                        validation="required|max:50"></text-field>
          </div>
          <div class="col-md-3">
            <text-field field-id="streetNumber"
                        label="Číslo domu"
                        placeholder="Zadaj číslo domu"
                        :maxlength="10"
                        v-model="customer.address.streetNumber"
                        validation="required|max:10"></text-field>
          </div>
          <div class="col-md-3">
            <text-field field-id="city"
                        label="Mesto"
                        placeholder="Zadaj mesto"
                        :maxlength="50"
                        v-model="customer.address.city"
                        validation="required|max:50"></text-field>
          </div>
          <div class="col-md-3">
            <text-field field-id="zipCode"
                        label="PSČ"
                        placeholder="Zadaj smerovacie číslo"
                        :maxlength="5"
                        v-model="customer.address.zipCode"
                        validation="required|max:5"></text-field>
          </div>
        </div>
      </form>
    </modalWindow>
  </div>
</template>

<script>
  import validationMixin from 'components/validationMixin';
  import textField from 'components/form/textField';
  import selectField from 'components/form/selectField';
  import numberField from 'components/form/numberField';
  import checkboxField from 'components/form/checkboxField';
  import textAreaField from 'components/form/textAreaField';
  import _ from 'lodash';
  import { mapState } from 'vuex';
  import modal from 'vue-strap/src/Modal';
  import { businessTypes } from 'codelist/';
  import eventBus from 'services/eventBus';
  import notificationService from 'services/notificationService';

  export default {
    components: {modalWindow: modal, textField, selectField, numberField, checkboxField, textAreaField},
    mixins: [validationMixin],
    data: () => ({
      show: false,
      vatPayer: false,
      hasParent: false,
      businessTypes,
      customer: null
    }),
    computed: {
      ...mapState({
        validAreas: (state, getters) => getters['area/validItems'],
        customers: (state) => state.customer.items
      })
    },
    props: {
      showModel: {
        type: Boolean,
        default () {
          return false;
        }
      },
      model: {
        type: Object
      }
    },
    methods: {
      vatId() {
        return this.vatPayer ? ('SK' + (this.customer.taxId || '')) : null;
      },
      editMode() {
        return !!(this.customer && this.customer.id);
      },
      createSubmit() {
        this.protect();
        this.$validator.validateAll().then((res) => {
          if (res) {
            let operation;
            if (this.customer.id) {
              operation = 'customer/update';
            } else {
              operation = 'customer/create';
            }
            const customer = _.cloneDeep(this.customer);
            customer.vatId = this.vatId();
            this.$store.dispatch(operation, customer).then((result) => {
              if (result) {
                notificationService.success('customer.edit.success');
                this.$emit('close');
              } else {
                this.unprotect();
              }
            }).catch(this.unprotect);
          } else {
            this.unprotect();
          }
        }).catch(this.unprotect);
      },
      clear() {
        this.vatPayer = false;
        this.hasParent = false;
        this.customer = null;
        this.unprotect();
        this.$nextTick(() => {
          eventBus.$emit('clear');
          this.errors.clear();
        });
      },
      cancel() {
        this.$emit('close');
      },
      onClose() {
        this.clear();
      }
    },
    watch: {
      model (model) {
          this.customer = _.cloneDeep(model);
          if (model && model.id) {
            this.vatPayer = !!this.customer.vatId;
            this.hasParent = !!this.customer.parent;
          }
      },
      showModel(showModel) {
        this.show = showModel;
      },
      hasParent(hasParent) {
        if (!this.customer) return;
        if (!hasParent) {
          this.customer.parent = null;
        }
      },
      'customer.parent': function (newParent, oldParent) {
        //isUndefined is check for first open in edit detail mode
        if (_.isUndefined(oldParent) || !newParent || (newParent === oldParent)) {
          return;
        }

        this.customer.newParent = newParent;
        this.customer.companyId = newParent.companyId;
        this.customer.taxId = newParent.taxId;
        if (newParent.vatId) {
          this.vatPayer = true;
          this.customer.vatId = newParent.vatId;
        } else {
          this.vatPayer = false;
          this.customer.vatId = null;
        }
        this.customer.address = _.cloneDeep(newParent.address);
      }
    },
    created () {
      this.$store.dispatch('customer/getAll');
      this.$store.dispatch('area/getAll');
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/customerCreateModal.vue